import React from 'react';

function Footer() {
  // Using Font Awesome for better visuals for social media icons.
  const socialLinks = [
    { name: 'Gmail', iconClass: 'fa-solid fa-envelope', url: 'mailto:dsouzacraigmichael@gmail.com' },
    { name: 'Instagram', iconClass: 'fa-brands fa-instagram', url: 'https://www.instagram.com/synthetica.in' },
    { name: 'LinkedIn', iconClass: 'fa-brands fa-linkedin', url: 'https://www.linkedin.com/company/vaybu' },
  ];

  // Additional footer links for common sections
  const companyLinks = [
    { name: 'About Us', url: '#' },
    { name: 'Careers', url: '#' },
    { name: 'Blog', url: '#' },
    { name: 'Press', url: '#' },
  ];

  const legalLinks = [
    { name: 'Privacy Policy', url: '/privacy' },
    { name: 'Terms of Service', url: '/termsofservice' },
    { name: 'Cookie Policy', url: '/cookiepolicy' },
  ];

  return (
    // Main container for the footer
    <div className="footer-container">
      {/* Subtle background pattern for texture */}
      <div className="background-pattern"></div>

      {/* Load Font Awesome for icons */}
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.2/css/all.min.css" xintegrity="sha512-SnH5WK+bZxgPHs44uWIX+LLJAJ9/2PkPKZ5QiAj6Ta86w+fsb2TkcmfRyVX3pBnMFcV7oQPJkl9QevSCWr3W6A==" crossOrigin="anonymous" referrerPolicy="no-referrer" />

      {/* Footer content wrapper */}
      <div className="footer-content-wrapper">
        {/* Main row for footer columns */}
        <div className="footer-columns-row">
          {/* Column 1: Synthetica Logo (now text) and Tagline */}
          <div className="footer-column">
            <h3 className="common-heading">SYNTHETICA</h3>
            <p className="footer-text tagline">A Trusted Vaybu Product</p>
          </div>

          {/* Column 2: Coming Soon Features (heading now text) */}
          <div className="footer-column">
            <h3 className="common-heading">Coming Soon</h3>
            <ul className="feature-list">
              <li className="footer-text feature-item">Plagiarism Detector</li>
              <li className="footer-text feature-item">Img/Video Authentication</li>
              <li className="footer-text feature-item">Deepfake Detection</li>
              <li className="footer-text feature-item">API Support</li>
            </ul>
          </div>

          {/* Column 3: Company Links */}
          <div className="footer-column">
            <h3 className="common-heading">Company</h3>
            <ul className="link-list">
              {companyLinks.map((link) => (
                <li key={link.name} className="link-item">
                  <a href={link.url} className="footer-link">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Contact Information & Social Media (heading now text) */}
          <div className="footer-column">
            <h3 className="common-heading">Contact Us</h3>
            {/* Row for social media icons */}
            <div className="social-icons-row">
              {socialLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={link.name}
                  className="social-icon"
                >
                  <i className={`${link.iconClass}`}></i>
                </a>
              ))}
            </div>
            <p className="footer-text contact-number">+91 7249478960</p>
          </div>
        </div>

        {/* Legal Links Section */}
        <div className="legal-links-section">
          {legalLinks.map((link) => (
            <a key={link.name} href={link.url} className="legal-link">
              {link.name}
            </a>
          ))}
        </div>
      </div>

      {/* Copyright section */}
      <div className="copyright-section">
        <div className="copyright-content-wrapper">
          <p className="copyright-text">&copy; 2026 Synthetica.in. All rights reserved.</p>
        </div>
      </div>

      {/* Inline CSS for styling */}
      <style>
        {`
        .footer-container {
          position: relative;
          background: linear-gradient(to top, #1a202c, #000000); /* Reverted to previous gradient: from-gray-900 to-black */
          width: 100%;
          color: #fff;
          font-family: 'Inter', sans-serif;
          border-radius: 1rem; /* rounded-xl */
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04); /* shadow-2xl */
          padding-bottom: 1rem; /* pb-4 */
          padding-top: 2rem; /* pt-8 */
          overflow: hidden;
        }

        .background-pattern {
          position: absolute;
          inset: 0;
          z-index: 0;
          opacity: 0.1;
          background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%239C92AC' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        }

        .footer-content-wrapper {
          position: relative;
          z-index: 10;
          display: flex;
          flex-direction: column;
          align-items: center;
          max-width: 84rem; /* max-w-7xl */
          margin-left: auto;
          margin-right: auto;
          padding: 3rem 1.5rem; /* px-6 py-12 */
        }
        @media (min-width: 768px) { /* md */
          .footer-content-wrapper {
            padding-top: 4rem; /* md:py-16 */
            padding-bottom: 4rem; /* md:py-16 */
          }
        }

        .footer-columns-row {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 100%;
          gap: 3rem; /* gap-12 */
        }
        @media (min-width: 768px) { /* md */
          .footer-columns-row {
            flex-direction: row;
            gap: 2rem; /* md:gap-8 */
          }
        }
        @media (min-width: 1024px) { /* lg */
          .footer-columns-row {
            gap: 4rem; /* lg:gap-16 */
          }
        }

        .footer-column {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          margin-left: auto;
          margin-right: auto;
          width: 100%; /* Default full width on small screens */
        }
        @media (min-width: 768px) { /* md */
          .footer-column {
            margin-left: 0;
            margin-right: 0;
            width: 25%; /* md:w-1/4 */
          }
        }
        @media (min-width: 1024px) { /* lg */
          .footer-column {
            width: 20%; /* lg:w-1/5 */
          }
        }

        .common-heading {
          font-size: 1.5rem; /* text-2xl */
          font-weight: 700; /* font-bold */
          color: #a78bfa; /* text-purple-400 */
          margin-bottom: 1.5rem; /* mb-6 */
        }
        @media (min-width: 768px) { /* md */
          .common-heading {
            font-size: 1.875rem; /* md:text-3xl */
          }
        }

        .heading-synthetica {
          font-size: 1.875rem; /* text-3xl */
          font-weight: 700; /* font-bold */
          color: #a78bfa; /* text-purple-400 */
          margin-bottom: 1.5rem; /* mb-6 */
        }
        @media (min-width: 768px) { /* md */
          .heading-synthetica {
            font-size: 2.25rem; /* md:text-4xl */
          }
        }

        .footer-text {
          color: #d1d5db; /* text-gray-300 */
          margin-top: 0.5rem; /* my-2 */
          margin-bottom: 0.5rem; /* my-2 */
          font-size: 1.125rem; /* text-lg */
        }
        @media (min-width: 768px) { /* md */
          .footer-text {
            font-size: 1.25rem; /* md:text-xl */
          }
        }

        .tagline {
          line-height: 1.625; /* leading-relaxed */
          margin-top: 1rem; /* mt-4 */
        }

        .feature-list, .link-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .feature-item, .link-item {
          margin-top: 0.5rem; /* my-2 */
          margin-bottom: 0.5rem; /* my-2 */
          cursor: pointer;
        }
        .feature-item:hover, .footer-link:hover {
          color: #a78bfa; /* hover:text-purple-400 */
          transition-property: color;
          transition-duration: 200ms;
          transition-timing-function: ease-in-out;
        }

        .footer-link {
          color: #d1d5db; /* text-gray-300 */
          text-decoration: none;
          font-size: 1.125rem; /* text-lg */
        }
        @media (min-width: 768px) { /* md */
          .footer-link {
            font-size: 1.25rem; /* md:text-xl */
          }
        }


        .social-icons-row {
          display: flex;
          flex-direction: row;
          justify-content: center;
          width: 100%;
          padding-top: 1.5rem; /* py-6 */
          padding-bottom: 1.5rem; /* py-6 */
        }

        .social-icon {
          margin: 0 1rem; /* mx-4 */
          color: #9ca3af; /* text-gray-400 */
          font-size: 2.25rem; /* text-4xl */
          transition-property: all;
          transition-duration: 300ms;
          transition-timing-function: ease-in-out;
          transform: scale(1);
        }
        .social-icon:hover {
          color: #a78bfa; /* hover:text-purple-400 */
          transform: scale(1.25) rotate(3deg); /* hover:scale-125 hover:rotate-3 */
        }

        .legal-links-section {
          width: 100%;
          margin-top: 3rem; /* mt-12 */
          padding-top: 2rem; /* pt-8 */
          border-top: 1px solid rgba(139, 92, 246, 0.5); /* border-purple-800/50 */
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 1.5rem; /* gap-6 */
        }
        @media (min-width: 768px) { /* md */
          .legal-links-section {
            flex-direction: row;
          }
        }

        .legal-link {
          color: #9ca3af; /* text-gray-400 */
          text-decoration: none;
          font-size: 1rem; /* text-md */
          transition-property: color;
          transition-duration: 200ms;
          transition-timing-function: ease-in-out;
        }
        @media (min-width: 768px) { /* md */
          .legal-link {
            font-size: 1.125rem; /* md:text-lg */
          }
        }
        .legal-link:hover {
          color: #a78bfa; /* hover:text-purple-400 */
        }

        .copyright-section {
          position: relative;
          z-index: 10;
          background-color: #000; /* bg-black */
          width: 100%;
          text-align: center;
          padding-top: 2rem; /* py-8 */
          padding-bottom: 2rem; /* py-8 */
          border-top: 1px solid #8b5cf6; /* border-purple-800 */
          border-bottom-left-radius: 1rem; /* rounded-b-xl */
          border-bottom-right-radius: 1rem; /* rounded-b-xl */
          box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06); /* shadow-inner */
        }

        .copyright-content-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          max-width: 84rem; /* max-w-6xl */
          margin-left: auto;
          margin-right: auto;
        }

        .copyright-text {
          font-size: 1rem; /* text-md */
          color: #9ca3af; /* text-gray-400 */
        }
        @media (min-width: 768px) { /* md */
          .copyright-text {
            font-size: 1.125rem; /* md:text-lg */
          }
        }
        `}
      </style>
    </div>
  );
}

export default Footer;
